//@flow
import {
  USER_FRIEND_REQUEST,
  EXTERNAL_USER_SET,
  EXTERNAL_USER_SET_FROM_ID,
  EXTERNAL_USER_SET_REQUESTING,
  EXTERNAL_USER_UNSET,
} from "./constants";

type addFriendType = {
  userId: string;
  friendId: string;
};
type fromIdType = {
  userId: string;
};

// utilisé ?
export const addFriend = (payload: addFriendType) => {
  return {
    type: USER_FRIEND_REQUEST,
    payload,
  };
};

// have change all (hope) _id to userId
export const requestExternalUser = (payload: { userId: string }) => {
  return {
    type: EXTERNAL_USER_SET_REQUESTING,
    payload,
  };
};

// difficile de savoir ce qui est à changé
export const setExternalUser = user => {
  return {
    type: EXTERNAL_USER_SET,
    user,
  };
};

// utilisé ?
export const setExternalUserFromId = (payload: fromIdType) => {
  return {
    type: EXTERNAL_USER_SET_FROM_ID,
    payload,
  };
};

export const unsetExternalUser = () => {
  return {
    type: EXTERNAL_USER_UNSET,
  };
};
